import { Component, Input } from "@angular/core";
import { Directory, DownloadFileOptions, Filesystem } from "@capacitor/filesystem";
import { FileService } from "src/app/services/file/file.service";

const CACHE_FOLDER = 'CACHED-IMG';


@Component({
  selector: "cached-image",
  templateUrl: "./cached-image.component.html",
  styleUrls: ["./cached-image.component.scss"]
})
export class CachedImageComponent{

  _src = '';
  @Input() spinnner = true;

  @Input() bw = false;

  @Input() rounded = false;

  @Input() default:string;

  source:string

  constructor(private fileService:FileService) {}

  @Input()
  set src(imageUrl:string){
    const inAssets = imageUrl.includes('assets/');
    const minSizeBase64 = 2000;
    //console.log(`in asset ${inAssets}`);
    if(imageUrl && !inAssets){
      //console.log('url:',imageUrl);
      const imageName = this.transformUrl(imageUrl);
      const path = `${CACHE_FOLDER}/${imageName}`;
      // console.log('url transformed:',imageName);
      Filesystem.readFile({
        directory:Directory.Cache,
        path: path
      }).then(readFile=>{
        // console.log(`local file read: ${imageName}`);
        if(readFile.data && readFile.data.toString().length > minSizeBase64){
          this._src = `data:image/jpg;base64,${readFile.data}`;
        }
        else{
          throw new Error('size issue');
        }
        this.source = 'local';
      }).catch(async e=>{
        const base64 = await this.downloadImage(imageUrl);
        // console.log(`no local file: ${imageName}`,base64.length);
        if(base64 && base64.length > minSizeBase64){
          const file = await this.storeImage(base64,imageName);
          const readFile = await this.getImage(path);
          this._src = `data:image/jpg;base64,${readFile.data}`;
          // console.log(`local file created: ${imageName}`);
          this.source = 'download';
        }
        else{
          // const fullSizeImage = this.getFullSizeImage(imageName);
          const fullSizeImageUrl = this.getFullSizeImage(imageUrl);
          // const base64FullSize = await this.downloadImage(fullSizeImageUrl);
          // this._src = `data:image/jpg;base64,${base64FullSize}`;
          // console.log('fullsize url',fullSizeImageUrl);
          this._src = fullSizeImageUrl;
          this.source = 'fullsize download';
        }
      })
    }
    else if(imageUrl && inAssets){
      this._src = imageUrl;
    }
    else{
      console.log('default image');
    }
    //console.log('_src',this._src);
  };

  async downloadImage(url:string){
    const response = await fetch(url);
    const blob = await response.blob();
    const base64 = await this.fileService.convertBlobToBase64(blob) as string;
    return base64;
  }

  async getImage(path){
    return Filesystem.readFile({
      directory:Directory.Cache,
      path: path
    });
  }

  async storeImage(base64,path){
    const savedFile = await Filesystem.writeFile({
      path:`${CACHE_FOLDER}/${path}`,
      data:base64,
      directory:Directory.Cache
    })
    //console.log( `file saved: ${path}`);
    return savedFile;
  }
  async downloadAndStoreImage(url,path){
    const downloadOptions: DownloadFileOptions = {
      path: `${CACHE_FOLDER}/${path}`,
      url:url
    };
    return await Filesystem.downloadFile(downloadOptions);
  }

  transformUrl(photoURL:string):string{
    const splitBySlash = photoURL.split('/');
    const lastElement = splitBySlash[splitBySlash.length-1];
    const withOutParams = lastElement.split('?')[0];
    const returnStrg = withOutParams.replace(/%2F/g,'-');
    const withExtension = returnStrg.split('.jpg')[0];
    //console.log(splitBySlash,lastElement,withOutParams,returnStrg, withExtension);
    return withExtension
  }

  getFullSizeImage(imageName:string):string{
    let fullSizeImage = imageName.replace('_300x300','').replace('_200x200','').replace('_1080x1080','');
    return fullSizeImage;
  }
}
